import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { UnmappedFormKey, UnmappedFormKeyListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const UNMAPPED_FORM_KEY_FIELDS = `id orgId workspaceId rawKey vendors createdDate updatedDate version`

const LIST_QUERY = graphql(`
  query UnmappedFormKeys($search: String, $pagination: PaginationInput, $sort: SortInput) {
    unmappedFormKeys(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        workspaceId
        rawKey
        vendors
        createdDate
        updatedDate
        version
      }
      total
      page
    }
  }
`)

export class UnmappedFormKeyStore extends EntityStore<UnmappedFormKey, UnmappedFormKeyListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: undefined,
      extractList: (data) => (data as { unmappedFormKeys: UnmappedFormKeyListResult }).unmappedFormKeys,
      extractOne: undefined,
      extractMutated: undefined,
    })
  }
}
